<script>
import Layout from "../../layouts/main";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      qrData: "", 
      responseUrl: '',
      parte_principal: {
        folioFiscal: 'CCC18AE4-E0A3-40FC-B613-137FC5C3F111',
        fechaExpedicion: '2025-06-12 01:44:00',
        fecha_certificacion_sat: '2025-06-12 01:51:17',
        estatus_cfdi: 'Activo'
      },
      parte_secundaria: {
        identificador_ccp: 'CCC18AE4-E0A3-40FC-B613-137FC5C3F111',
        fecha_salida_llegada: '12/06/2025 01:44:00 a. m.',
        fecha_certificacion: '12/06/2025 01:51:17 a. m.',
        estatus_cfdi: 'Activo'
      },
      parte_autotransporte: {
        configuracion_vehicular: 'Tractocamión Semirremolque-Remolque (10 llantas en el tractocamión, 8 llantas en el semirremolque y 16 llantas en el remolque)',
        placa_vm: '26BF8Z',
        remolques: [
          { subtipo: 'Tanque', placa: '12UV7K' },
          { subtipo: 'Tanque', placa: '12UV7K' }
        ],
        ubicaciones: {
          fecha_hora_origen: '12/06/2025 01:44:00 a. m.',
          pais_origen: 'México',
          fecha_hora_destino: '12/06/2025 02:11:00 a. m.',
          distancia_recorrida: '16'
        },
        ubicacion_origen: {
          origen: true,
          pais: 'México',
          estado: 'NLE'
        },
        ubicacion_destino: {
          destino: true,
          pais: 'México',
          estado: 'NLE'
        },
        mercancias: {
          numero_total: '1',
          material_peligroso: true,
          sector_cofepris: false,
          guias_identificacion: false,
          hidrocarburos: false,
          logistica_inversa: false
        },
        mercancia_mayor_volumen: {
          descripcion: 'DIESEL',
          cantidad: '63000',
          unidad: 'Litro',
          no_pedimento: ''
        }
      },
      parte_figura_transporte: {
        tipo_figura: 'Operador',
        numero_licencia: 'MICH109473',
        registro_identidad: '',
        residencia_fiscal: '',
        bienes_transportados: '15101505',
        descripcion:'Combustible diesel'
      },
      parte_datos_generales_carta_porte: {
        transporte_internacional: 'No',
        entrada_salida_mercancia: '',
        pais_origen_destino: '',
        mercancia: 'DIESEL',
        total_distancia_recorrida: '16',
        registro_istmo: '',
        ubicacion_polo_origen: '',
        ubicacion_polo_destino: ''
      },
      parte_ubicaciones: [
        {
          tipo_ubicacion: 'Origen',
          identificacion_ubicacion: '',
          rfc_remitente_destinatario: 'MPR1611247A4',
          nombre_remitente_destinatario: 'PATIO MPR ESCOBEDO NL',
          numero_registro_identidad_tributaria: '',
          residencia_fiscal: '',
          numero_estacion: '',
          nombre_estacion: '',
          navegacion_trafico: '',
          fecha_hora_salida_llegada: '12/06/2025 01:44:00 a. m.',
          tipo_estacion: '',
          distancia_recorrida: '',
          pais: 'México',
          codigo_postal: '66080',
          estado: 'Nuevo León',
          municipio: 'General Escobedo',
          localidad: 'Ciudad General Escobedo',
          colonia: 'Andres Caballero Moreno Agrop',
          calle: 'LOS TREVIÑO EN SAN JOSE  DE LOS SAUCES',
          numero_exterior: 'S/N',
          numero_interior: '',
          referencia: ''
        },
        {
          tipo_ubicacion: 'Destino',
          identificacion_ubicacion: '',
          rfc_remitente_destinatario: 'SJC2012184T5',
          nombre_remitente_destinatario: 'SERVIEXPRESS JC',
          numero_registro_identidad_tributaria: '',
          residencia_fiscal: '',
          numero_estacion: '',
          nombre_estacion: '',
          navegacion_trafico: '',
          fecha_hora_salida_llegada: '12/06/2025 02:11:00 a. m.',
          tipo_estacion: '',
          distancia_recorrida: '16',
          pais: 'México',
          codigo_postal: '66630',
          estado: 'Nuevo León',
          municipio: 'Apodaca',
          localidad: 'Ciudad Apodaca',
          colonia: 'El Mezquital',
          calle: 'CARRETERA MEZQUITAL-SANTA ROSA',
          numero_exterior: '3517',
          numero_interior: '',
          referencia: ''
        }
      ],
      parte_mercancias: {
        peso_bruto_total: '58000',
        unidad_peso: 'Litro',
        peso_neto_total: '0',
        numero_total_mercancias: '1',
        logistica_inversa: '',
        bienes_transportados: 'Combustible diesel',
        descripcion: 'DIESEL',
        cantidad: '63000',
        clave_unidad: 'Litro',
        unidad: 'LITRO',
        material_peligroso: 'Sí',
        clave_material_peligroso: 'GASOLEO o COMBUSTIBLE PARA MOTORES DIESEL o ACEITE MINERAL LIGERO PARA CALEFACCIÓN',
        embalaje: 'No aplica',
        peso_en_kg: '58000',
        fraccion_arancelaria: '',
        sector_cofepris: '',
        nombre_ingrediente_activo: '',
        nombre_quimico: '',
        denominacion_generica_producto: '',
        denominacion_distintiva_producto: '',
        fabricante: '',
        forma_farmaceutica: '',
        condiciones_especiales_transporte: '',
        registro_sanitario: '',
        folio_permiso_importacion: '',
        fecha_caducidad: '',
        lote: '',
        folio_permiso_importacion_vucem: '',
        numero_cas: '',
        razon_social_importadora: '',
        numero_registro_sanitario_plaguicidas: '',
        datos_fabricante_ia: '',
        datos_formulador: '',
        datos_maquilador: '',
        uso_autorizado: '',
        tipo_material: '',
        descripcion_material: ''
      },
      parte_transportes: {
        tipo_permiso_sct: 'Autotransporte Federal de Carga Especializada de materiales y residuos peligrosos.',
        numero_permiso_sct: '254LUB28102021230301002',
        configuracion_vehicular: 'Tractocamión Semirremolque-Remolque (10 llantas en el tractocamión, 8 llantas en el semirremolque y 16 llantas en el remolque)',
        peso_bruto_vehicular: '25858',
        placa_vm: '26BF8Z',
        anio_modelo_vm: '2022',
        aseguradora_responsabilidad_civil: 'QUALITAS',
        poliza_responsabilidad_civil: '0870276473',
        aseguradora_medio_ambiente: 'QUALITAS',
        poliza_medio_ambiente: '0870276473',
        remolques: [
          { subtipo_remolque: 'Tanque', placa: '12UV7K' },
          { subtipo_remolque: 'Tanque', placa: '13UV7K' }
        ]
      }
    }
  },
  computed: {
      qrCodeUrl() {
      return `https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(this.responseUrl)}`;
    },
  },
  
  methods: {
    async crearCarpeta() {
  const payload = {
    parte_principal: this.parte_principal,
    parte_secundaria: this.parte_secundaria,
    parte_autotransporte: this.parte_autotransporte,
    parte_figura_transporte: this.parte_figura_transporte,
    parte_datos_generales_carta_porte: this.parte_datos_generales_carta_porte,
    parte_ubicaciones: this.parte_ubicaciones,
    parte_mercancias: this.parte_mercancias,
    parte_transportes: this.parte_transportes
  };

  try {
    const response = await fetch('https://verificacfdi.facturaelectronica.sat.siatsat.mx/api/carta-porte', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error('Error en la petición');
    }

    const data = await response.json();
    this.responseUrl = data.url;
    alert('Datos cargados correctamente');

  } catch (error) {
    alert('Error al cargar los datos: ' + error.message);
  }
},
  downloadQR() {
      const link = document.createElement("a");
      link.href = this.qrCodeUrl;
      link.download = "qrCode.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
}}
</script>
<template>
    <Layout>
      <div class="col-xl-12">
        <h5 class="title-home">Verificador del complemento Carta Porte<span class="dot-home">.</span></h5>
        <form style="font-size: 12px !important;" @submit.prevent="crearCarpeta" class="form-container">
          <div id="parte_principal" class="w-100 d-flex">
            <div class="form-group">
              <label for="folioFiscal"><b>Identificador del Complemento Carta Porte <span class="required">*</span>:</b></label>
              <input v-model="parte_principal.folioFiscal" name="folioFiscal" id="folioFiscal" type="text" maxlength="36" class="form-control" placeholder="________-____-____-____-____________" style="text-transform: uppercase;">
            </div>
            <div class="form-group">
              <label for="fechaExpedicion"><b>Fecha y hora de Origen <span class="required">*</span>:</b></label>
              <div class="input-group datexx">
                <input v-model="parte_principal.fechaExpedicion" name="fechaExpedicion" id="fechaExpedicion" type="text" maxlength="20" class="form-control">
                <span class="input-group-addon"></span>
              </div>
            </div>
            <div class="form-group">
              <label for="fecha_certificacion_sat"><b>Fecha y hora de Certificación <span class="required">*</span>:</b></label>
              <div class="input-group datexx">
                <input v-model="parte_principal.fecha_certificacion_sat" name="fecha_certificacion_sat" id="fecha_certificacion_sat" type="text" maxlength="20" class="form-control">
                <span class="input-group-addon"></span>
              </div>
            </div>
          </div>
          
          <div id="parte_secundaria" class="w-100 d-flex mt-4">
            <div class="form-group">
              <label for="identificador_ccp"><b>Identificación del Complemento Carta Porte:</b></label>
              <input v-model="parte_secundaria.identificador_ccp" name="identificador_ccp" id="identificador_ccp" type="text" class="form-control" placeholder="Identificación del Complemento Carta Porte">
            </div>
            <div class="form-group">
              <label for="fecha_salida_llegada"><b>Fecha hora de salida o llegada origen:</b></label>
              <input v-model="parte_secundaria.fecha_salida_llegada" name="fecha_salida_llegada" id="fecha_salida_llegada" type="text" class="form-control" placeholder="Fecha hora de salida o llegada origen">
            </div>
            <div class="form-group">
              <label for="fecha_certificacion"><b>Fecha y hora de certificación:</b></label>
              <input v-model="parte_secundaria.fecha_certificacion" name="fecha_certificacion" id="fecha_certificacion" type="text" class="form-control" placeholder="Fecha y hora de certificación">
            </div>
            <div class="form-group">
              <label for="estatus_cfdi"><b>Estatus del CFDI:</b></label>
              <input v-model="parte_secundaria.estatus_cfdi" name="estatus_cfdi" id="estatus_cfdi" type="text" class="form-control" placeholder="Estatus del CFDI">
            </div>
          </div>
          <div id="parte_autotransporte" class="autotransporte-section mt-4">
            <h4 class="section-title">Autotransporte</h4>
            <div class="autotransporte-box">
              <div class="row">
                <div class="col-md-5">
                  <label><b>Configuración Vehicular</b></label>
                  <textarea v-model="parte_autotransporte.configuracion_vehicular" class="form-control" rows="4" placeholder="Configuración Vehicular"></textarea>
                </div>
                <div class="col-md-3">
                  <label><b>Placa VM</b></label>
                  <input v-model="parte_autotransporte.placa_vm" class="form-control" type="text" placeholder="Placa VM">
                </div>
                <div class="col-md-4">
                  <label><b>Remolques</b></label>
                  <div class="remolque-row">
                    <div class="remolque-col">
                      <label>Subtipo Remolque</label>
                      <input v-model="parte_autotransporte.remolques[0].subtipo" class="form-control" type="text" placeholder="Subtipo Remolque">
                      <input v-model="parte_autotransporte.remolques[1].subtipo" class="form-control mt-2" type="text" placeholder="Subtipo Remolque">
                    </div>
                    <div class="remolque-col">
                      <label>Placa</label>
                      <input v-model="parte_autotransporte.remolques[0].placa" class="form-control" type="text" placeholder="Placa">
                      <input v-model="parte_autotransporte.remolques[1].placa" class="form-control mt-2" type="text" placeholder="Placa">
                    </div>
                  </div>
                </div>
              </div>
              <div class="autotransporte-subbox mt-3">
                <h5 class="section-title">Ubicaciones</h5>
                <div class="row">
                  <div class="col-md-3">
                    <label>Fecha y Hora del Origen</label>
                    <input v-model="parte_autotransporte.ubicaciones.fecha_hora_origen" class="form-control" type="text" placeholder="Fecha y Hora del Origen">
                  </div>
                  <div class="col-md-3">
                    <label>País de Origen</label>
                    <input v-model="parte_autotransporte.ubicaciones.pais_origen" class="form-control" type="text" placeholder="País de Origen">
                  </div>
                  <div class="col-md-3">
                    <label>Fecha y Hora del destino</label>
                    <input v-model="parte_autotransporte.ubicaciones.fecha_hora_destino" class="form-control" type="text" placeholder="Fecha y Hora del destino">
                  </div>
                  <div class="col-md-3">
                    <label>Total Distancia Recorrida</label>
                    <input v-model="parte_autotransporte.ubicaciones.distancia_recorrida" class="form-control" type="text" placeholder="Total Distancia Recorrida">
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-4">
                    <div class="ubicacion-box">
                      <div class="d-flex align-items-center mb-2">
                        <input type="checkbox" v-model="parte_autotransporte.ubicacion_origen.origen" id="origen1">
                        <label for="origen1" class="ml-2 mb-0">Origen</label>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <label>País</label>
                          <input v-model="parte_autotransporte.ubicacion_origen.pais" class="form-control" type="text" placeholder="País">
                        </div>
                        <div class="col-6">
                          <label>Estado</label>
                          <input v-model="parte_autotransporte.ubicacion_origen.estado" class="form-control" type="text" placeholder="Estado">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="ubicacion-box">
                      <div class="d-flex align-items-center mb-2">
                        <input type="checkbox" v-model="parte_autotransporte.ubicacion_destino.destino" id="destino1">
                        <label for="destino1" class="ml-2 mb-0">Destino</label>
                      </div>
                      <div class="row">
                        <div class="col-6">
                          <label>País</label>
                          <input v-model="parte_autotransporte.ubicacion_destino.pais" class="form-control" type="text" placeholder="País">
                        </div>
                        <div class="col-6">
                          <label>Estado</label>
                          <input v-model="parte_autotransporte.ubicacion_destino.estado" class="form-control" type="text" placeholder="Estado">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="autotransporte-subbox mt-3">
                <div class="row">
                  <div class="col-md-6">
                    <h5 class="section-title">Mercancías</h5>
                    <label>Número Total</label>
                    <input v-model="parte_autotransporte.mercancias.numero_total" class="form-control" type="text" placeholder="Número Total">
                    <div class="mt-2">
                      <label class="d-block"><b>Descripción Específica</b></label>
                      <div class="checkbox-list">
                        <div><input type="checkbox" v-model="parte_autotransporte.mercancias.material_peligroso" id="material_peligroso"><label for="material_peligroso" class="ml-2">Material Peligroso</label></div>
                        <div><input type="checkbox" v-model="parte_autotransporte.mercancias.sector_cofepris" id="sector_cofepris"><label for="sector_cofepris" class="ml-2">Sector COFEPRIS</label></div>
                        <div><input type="checkbox" v-model="parte_autotransporte.mercancias.guias_identificacion" id="guias_identificacion"><label for="guias_identificacion" class="ml-2">Guías Identificación</label></div>
                        <div><input type="checkbox" v-model="parte_autotransporte.mercancias.hidrocarburos" id="hidrocarburos"><label for="hidrocarburos" class="ml-2">Hidrocarburos</label></div>
                        <div><input type="checkbox" v-model="parte_autotransporte.mercancias.logistica_inversa" id="logistica_inversa"><label for="logistica_inversa" class="ml-2">Logística Inversa Recolección</label></div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h5 class="section-title">Mercancía con Mayor Volumen</h5>
                    <div class="row">
                      <div class="col-6">
                        <label>Descripción</label>
                        <input v-model="parte_autotransporte.mercancia_mayor_volumen.descripcion" class="form-control" type="text" placeholder="Descripción">
                      </div>
                      <div class="col-6">
                        <label>Cantidad</label>
                        <input v-model="parte_autotransporte.mercancia_mayor_volumen.cantidad" class="form-control" type="text" placeholder="Cantidad">
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-6">
                        <label>Unidad</label>
                        <input v-model="parte_autotransporte.mercancia_mayor_volumen.unidad" class="form-control" type="text" placeholder="Unidad">
                      </div>
                      <div class="col-6">
                        <label>No. de Pedimento</label>
                        <input v-model="parte_autotransporte.mercancia_mayor_volumen.no_pedimento" class="form-control" type="text" placeholder="No. de Pedimento">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Figura Transporte -->
          <div style="padding: 20px;" id="parte_figura_transporte" class="figura-transporte-section mt-4">
            <div class="figura-header">
<h4 class="section-title">Figura Transporte</h4>            </div>
            <div class="figura-content">
              <div class="row">
                <div class="form-group">
                  <label>Tipo de Figura</label>
                  <input v-model="parte_figura_transporte.tipo_figura" class="form-control" type="text" placeholder="Operador">
                </div>
                <div class="form-group">
                  <label>Número de Licencia</label>
                  <input v-model="parte_figura_transporte.numero_licencia" class="form-control" type="text" placeholder="MICH109473">
                </div><br>
                <div class="form-group">
                  <label>Número de Registro de Identidad Tributaria de la Figura</label>
                  <input v-model="parte_figura_transporte.registro_identidad" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Residencia Fiscal de la Figura</label>
                  <input v-model="parte_figura_transporte.residencia_fiscal" class="form-control" type="text">
                </div>
              </div>
              <hr class="figura-divider" />
              <div class="row">
                <div class="form-group">
                  <label>Bienes Transportados</label>
                  <input v-model="parte_figura_transporte.bienes_transportados" class="form-control" type="text" placeholder="15101505">
                </div>
                <div class="form-group">
                  <label>Descripción</label>
                  <input v-model="parte_figura_transporte.descripcion_bienes" class="form-control" type="text" placeholder="Combustible diesel">
                </div>
              </div>
            </div>
          </div>
          <!-- Datos Generales Carta Porte -->
          <div style="padding:20px;" id="parte_datos_generales_carta_porte" class="figura-transporte-section mt-4">
            <div class="figura-header">
            </div>
            <div class="figura-content">
              <div class="form-group w-100">
                <h4 class="section-title">Datos Generales Carta Porte</h4>
              </div>
              <div class="row">
                <div class="form-group">
                  <label>Transporte Internacional</label>
                  <input v-model="parte_datos_generales_carta_porte.transporte_internacional" class="form-control" type="text" placeholder="No">
                </div>
                <div class="form-group">
                  <label>Entrada/Salida de Mercancía</label>
                  <input v-model="parte_datos_generales_carta_porte.entrada_salida_mercancia" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>País de Origen o Destino</label>
                  <input v-model="parte_datos_generales_carta_porte.pais_origen_destino" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Mercancía</label>
                  <input v-model="parte_datos_generales_carta_porte.mercancia" class="form-control" type="text" placeholder="DIESEL">
                </div>
                <div class="form-group">
                  <label>Total Distancia Recorrida</label>
                  <input v-model="parte_datos_generales_carta_porte.total_distancia_recorrida" class="form-control" type="text" placeholder="16">
                </div>
              </div>
              <div class="row">
                <div class="form-group">
                  <label>Registro ISTMO</label>
                  <input v-model="parte_datos_generales_carta_porte.registro_istmo" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Ubicación Polo Origen</label>
                  <input v-model="parte_datos_generales_carta_porte.ubicacion_polo_origen" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Ubicación Polo Destino</label>
                  <input v-model="parte_datos_generales_carta_porte.ubicacion_polo_destino" class="form-control" type="text">
                </div>
              </div>
            </div>
          </div>
          
          <!-- Ubicaciones y Domicilio -->
          <div id="parte_ubicaciones" class="mt-4">
            <h4 class="section-title">Ubicación</h4>
            <div v-for="(ubicacion, idx) in parte_ubicaciones" :key="idx" class="ubicacion-bloque mb-4">
              <div class="row">
                <div class="form-group">
                  <label>Tipo de Ubicación</label>
                  <input v-model="ubicacion.tipo_ubicacion" class="form-control" type="text" placeholder="Destino">
                </div>
                <div class="form-group">
                  <label>Identificación de la Ubicación</label>
                  <input v-model="ubicacion.identificacion_ubicacion" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>RFC del Remitente o Destinatario</label>
                  <input v-model="ubicacion.rfc_remitente_destinatario" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Nombre del Remitente o Destinatario</label>
                  <input v-model="ubicacion.nombre_remitente_destinatario" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Número de Registro de Identidad Tributaria</label>
                  <input v-model="ubicacion.numero_registro_identidad_tributaria" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Residencia Fiscal</label>
                  <input v-model="ubicacion.residencia_fiscal" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Número de Estación</label>
                  <input v-model="ubicacion.numero_estacion" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Nombre de Estación</label>
                  <input v-model="ubicacion.nombre_estacion" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Navegación Tráfico</label>
                  <input v-model="ubicacion.navegacion_trafico" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Fecha Hora de Salida o Llegada</label>
                  <input v-model="ubicacion.fecha_hora_salida_llegada" class="form-control" type="text" placeholder="dd/mm/yyyy hh:mm:ss">
                </div>
                <div class="form-group">
                  <label>Tipo Estación</label>
                  <input v-model="ubicacion.tipo_estacion" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Distancia Recorrida</label>
                  <input v-model="ubicacion.distancia_recorrida" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>País</label>
                  <input v-model="ubicacion.pais" class="form-control" type="text" placeholder="México">
                </div>
                <div class="form-group">
                  <label>Código Postal</label>
                  <input v-model="ubicacion.codigo_postal" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Estado</label>
                  <input v-model="ubicacion.estado" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Municipio</label>
                  <input v-model="ubicacion.municipio" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Localidad</label>
                  <input v-model="ubicacion.localidad" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Colonia</label>
                  <input v-model="ubicacion.colonia" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Calle</label>
                  <input v-model="ubicacion.calle" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Número Exterior</label>
                  <input v-model="ubicacion.numero_exterior" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Número Interior</label>
                  <input v-model="ubicacion.numero_interior" class="form-control" type="text">
                </div>
                <div class="form-group">
                  <label>Referencia</label>
                  <input v-model="ubicacion.referencia" class="form-control" type="text">
                </div>
              </div>
            </div>
          </div>
          
          <!-- Mercancías -->
          <div id="parte_mercancias" class="mt-4">
            <h4 class="section-title">Mercancías</h4>
            <div class="row">
              <div class="form-group">
                <label>Peso Bruto Total</label>
                <input v-model="parte_mercancias.peso_bruto_total" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Unidad Peso</label>
                <input v-model="parte_mercancias.unidad_peso" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Peso Neto Total</label>
                <input v-model="parte_mercancias.peso_neto_total" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Número Total Mercancías</label>
                <input v-model="parte_mercancias.numero_total_mercancias" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Logística Inversa/Recolección/Devolución</label>
                <input v-model="parte_mercancias.logistica_inversa" class="form-control" type="text">
              </div>
            </div>
            <hr>
            <h4 class="section-title">Mercancía</h4>
            <div class="row">
              <div class="form-group">
                <label>Bienes Transportados</label>
                <input v-model="parte_mercancias.bienes_transportados" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Descripción</label>
                <input v-model="parte_mercancias.descripcion" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Cantidad</label>
                <input v-model="parte_mercancias.cantidad" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Clave Unidad</label>
                <input v-model="parte_mercancias.clave_unidad" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Unidad</label>
                <input v-model="parte_mercancias.unidad" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Material Peligroso</label>
                <input v-model="parte_mercancias.material_peligroso" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Clave Material Peligroso</label>
                <input v-model="parte_mercancias.clave_material_peligroso" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Embalaje</label>
                <input v-model="parte_mercancias.embalaje" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Peso en Kg</label>
                <input v-model="parte_mercancias.peso_en_kg" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Fracción Arancelaria</label>
                <input v-model="parte_mercancias.fraccion_arancelaria" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Sector COFEPRIS</label>
                <input v-model="parte_mercancias.sector_cofepris" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Nombre del Ingrediente Activo</label>
                <input v-model="parte_mercancias.nombre_ingrediente_activo" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Nombre Químico</label>
                <input v-model="parte_mercancias.nombre_quimico" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Denominación Genérica del Producto</label>
                <input v-model="parte_mercancias.denominacion_generica_producto" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Denominación Distintiva del Producto</label>
                <input v-model="parte_mercancias.denominacion_distintiva_producto" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Fabricante</label>
                <input v-model="parte_mercancias.fabricante" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Forma Farmacéutica</label>
                <input v-model="parte_mercancias.forma_farmaceutica" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Condiciones Especiales Requeridas del Transporte</label>
                <input v-model="parte_mercancias.condiciones_especiales_transporte" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Registro Sanitario o Folio de Autorización Sanitaria de no Contar con Registro</label>
                <input v-model="parte_mercancias.registro_sanitario" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Folio de Permiso de Importación (Ingresado de Manera Presencial)</label>
                <input v-model="parte_mercancias.folio_permiso_importacion" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Fecha de Caducidad/Fecha de Reanálisis</label>
                <input v-model="parte_mercancias.fecha_caducidad" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Lote</label>
                <input v-model="parte_mercancias.lote" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Folio de Permiso de Importación VUCEM</label>
                <input v-model="parte_mercancias.folio_permiso_importacion_vucem" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Número CAS</label>
                <input v-model="parte_mercancias.numero_cas" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Razón Social de la Empresa Importadora</label>
                <input v-model="parte_mercancias.razon_social_importadora" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Número de Registro Sanitario de Plaguicidas/Registro Sanitario de Nutrientes Vegetales Ante COFEPRIS</label>
                <input v-model="parte_mercancias.numero_registro_sanitario_plaguicidas" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Datos del Fabricante I.A (País Razón Social)</label>
                <input v-model="parte_mercancias.datos_fabricante_ia" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Datos del Formulador</label>
                <input v-model="parte_mercancias.datos_formulador" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Datos del Maquilador</label>
                <input v-model="parte_mercancias.datos_maquilador" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Uso Autorizado</label>
                <input v-model="parte_mercancias.uso_autorizado" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Tipo de Material</label>
                <input v-model="parte_mercancias.tipo_material" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Descripción</label>
                <input v-model="parte_mercancias.descripcion_material" class="form-control" type="text">
              </div>
            </div>
          </div>
          
          <!-- Transportes -->
          <div id="parte_transportes" class="mt-4">
            <h3 style="color:#2d554d;font-weight:bold;">Transportes</h3>
            <hr>
            <h4 class="section-title">Autotransporte</h4>
            <div class="row">
              <div class="form-group">
                <label>Tipo de Permiso SCT</label>
                <input v-model="parte_transportes.tipo_permiso_sct" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Número de Permiso SCT</label>
                <input v-model="parte_transportes.numero_permiso_sct" class="form-control" type="text">
              </div>
            </div>
            <h5 class="section-title">Identificador Vehicular</h5>
            <div class="row">
              <div class="form-group">
                <label>Configuración Vehicular</label>
                <input v-model="parte_transportes.configuracion_vehicular" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Peso Bruto Vehicular</label>
                <input v-model="parte_transportes.peso_bruto_vehicular" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Placa VM</label>
                <input v-model="parte_transportes.placa_vm" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Año Modelo VM</label>
                <input v-model="parte_transportes.anio_modelo_vm" class="form-control" type="text">
              </div>
            </div>
            <h5 class="section-title">Seguros</h5>
            <div class="row">
              <div class="form-group">
                <label>Aseguradora de Responsabilidad Civil</label>
                <input v-model="parte_transportes.aseguradora_responsabilidad_civil" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Póliza de Responsabilidad Civil</label>
                <input v-model="parte_transportes.poliza_responsabilidad_civil" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Aseguradora Medio Ambiente</label>
                <input v-model="parte_transportes.aseguradora_medio_ambiente" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Póliza Medio Ambiente</label>
                <input v-model="parte_transportes.poliza_medio_ambiente" class="form-control" type="text">
              </div>
            </div>
            <h5 class="section-title">Remolques</h5>
            <div class="row">
              <div class="form-group">
                <label>Subtipo Remolque</label>
                <input v-model="parte_transportes.remolques[0].subtipo_remolque" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Placa</label>
                <input v-model="parte_transportes.remolques[0].placa" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Subtipo Remolque</label>
                <input v-model="parte_transportes.remolques[1].subtipo_remolque" class="form-control" type="text">
              </div>
              <div class="form-group">
                <label>Placa</label>
                <input v-model="parte_transportes.remolques[1].placa" class="form-control" type="text">
              </div>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-end mt-4">
            <button type="submit" class="btn btn-primary">Enviar datos</button>
          </div>
        </form>
          <div v-if="responseUrl">
          <p style="padding-top:15px;">URL Factura Electrónica:<br> <a :href="responseUrl" target="_blank">{{ responseUrl }}</a></p>
          <img :src="qrCodeUrl" alt="QR Code" />
          <br><button style="margin-top:15px;" @click="downloadQR" class="btn btn-primary">Descargar QR</button>
        </div>
        </div>
    </Layout>
  </template>
  
  <style>
  .figura-transporte-section {
    border-radius: 8px;
    margin-bottom: 32px;
    box-shadow: 0 2px 8px #0001;
  }
  .figura-header {
    font-size: 1.4rem;
    font-weight: bold;
    padding: 10px 18px;
    border-radius: 8px 8px 0 0;
    letter-spacing: 0.5px;
  }
  .figura-content {
    padding: 18px 18px 10px 18px;
  }
  .figura-divider {
    margin: 24px 0 18px 0;
    border: none;
  }
  .form-container {
    display: flex;
    flex-wrap: wrap;
  }
  
  .form-group {
    width: calc(33.33% - 20px); /* Tres columnas con un pequeño margen */
    margin-right: 10px;
    margin-bottom: 32px;
  }

  #parte_secundaria .form-group {
    margin-bottom: 32px;
  }

  #parte_secundaria .form-group input {
    margin-top: 16px;
    margin-bottom: 0;
  }

  #parte_secundaria .form-group {
    padding-right: 8px;
  }

  #parte_secundaria {
    gap: 8px;
  }
  
  .form-group label {
    display: block;
  }
  
  .required {
    color: #247ba0;
  }
  
  .form-group:nth-child(3n) {
    margin-right: 0; /* Eliminar margen derecho para el último elemento de cada fila */
  }
  
  button.btn.button-client-form.btn-primary {
    margin-top: 30px;
  }
  .custom-table th {
    background: #f5f5f5;
    font-size: 1.25rem;
    font-weight: bold;
    color: #222;
    border: 1px solid #e0e0e0;
    text-align: left;
    padding: 12px 16px;
  }
  .custom-table td {
    font-size: 1.1rem;
    color: #444;
    border: 1px solid #e0e0e0;
    padding: 10px 16px;
    vertical-align: middle;
  }
  .custom-table input.form-control {
    font-size: 1.1rem;
    padding: 6px 10px;
    width: 100%;
    background: #fff;
    border: 1px solid #bfcfc2;
    border-radius: 6px;
  }
  .table-responsive {
    margin-top: 32px;
  }
  .mt-5 {
    margin-top: 3rem !important;
  }
  .mt-4 {
    margin-top: 1.5rem !important;
  }
  .w-100 {
    width: 100% !important;
  }
  .d-flex {
    display: flex !important;
  }
  @media (max-width: 991px) {
    .custom-table th, .custom-table td {
      font-size: 1rem;
      padding: 8px 6px;
    }
  }
  .autotransporte-section {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px #0001;
    padding: 18px 18px 10px 18px;
    margin-bottom: 32px;
    border: 1px solid #e0e0e0;
  }
  .autotransporte-box {
    background: #fafafa;
    border-radius: 10px;
    padding: 18px 12px 12px 12px;
    border: 1px solid #e0e0e0;
    margin-bottom: 18px;
  }
  .autotransporte-subbox {
    background: #fff;
    border-radius: 10px;
    padding: 16px 12px 12px 12px;
    border: 1px solid #e0e0e0;
    margin-bottom: 18px;
  }
  .section-title {
    font-size: 1.3rem;
    font-weight: bold;
    margin-bottom: 10px;
    color: #222;
  }
  .remolque-row {
    display: flex;
    gap: 16px;
  }
  .remolque-col {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .ubicacion-box {
    background: #f5f5f5;
    border-radius: 8px;
    padding: 12px 10px 10px 10px;
    border: 1px solid #e0e0e0;
    margin-bottom: 8px;
  }
  .checkbox-list > div {
    margin-bottom: 6px;
    display: flex;
    align-items: center;
  }
  .checkbox-list label {
    margin-bottom: 0;
    margin-left: 6px;
    font-weight: 400;
  }
  .ml-2 {
    margin-left: 8px;
  }
  .mb-0 {
    margin-bottom: 0;
  }
  .mt-2 {
    margin-top: 8px;
  }
  .mt-3 {
    margin-top: 18px;
  }
  .align-items-center {
    align-items: center;
  }
  @media (max-width: 991px) {
    .autotransporte-section, .autotransporte-box, .autotransporte-subbox {
      padding: 10px 4px;
    }
    .remolque-row {
      flex-direction: column;
      gap: 8px;
    }
    .row {
      flex-direction: column;
    }
    .col-md-3, .col-md-4, .col-md-5, .col-md-6 {
      width: 100%;
      max-width: 100%;
    }
  }
  </style>
  
